module.exports = __webpack_public_path__ + "awards_bg.png";